<template>
  <div class="app-container">
    <CrudTable entity="Currency" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        'description',
        { field: 'symbol', label: 'currency.symbol' },
        { field: 'isoCode', label: 'currency.isoCode' }
      ]
    };
  }
};
</script>

<style scoped></style>
